import { render } from "./DeleteCredentials.vue?vue&type=template&id=33af693a"
import script from "./DeleteCredentials.vue?vue&type=script&lang=js"
export * from "./DeleteCredentials.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sivasankarelango/Sivasankar/test-cx/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__